import { reducer } from './reducer';

export * from './actions';
export * from './selectors';

const common = {
  reducer,
};

export default common;
